<mat-sidenav-container autosize>
  <mat-sidenav [mode]="isMobile || noMenu ? 'over' : 'side'" [opened]="!(isMobile || noMenu)" class="!bg-black">
    <mat-nav-list>
      @if (!isMobile) {
      <a mat-list-item (click)="toggleMenu()">
        <span class="entry text-white">
          <mat-icon>menu</mat-icon>
        </span>
      </a>
      }
      <a mat-list-item
         [routerLink]="'/home'"
         [routerLinkActive]="path === '/home' ? '!bg-blue-600' : ''"
      >
        <span class="entry text-white">
          <mat-icon>house</mat-icon>
          <span *ngIf="!isCollapsed">Dashboard</span>
        </span>
      </a>
      @for(integration of customerIntegrations; track integration.id) {
        <a mat-list-item
           [routerLink]="'/integrations/' + integration.type + '/settings'"
           [routerLinkActive]="path === '/integrations/' + integration.type + '/settings' ? '!bg-blue-600' : ''"
        >
        <span class="entry text-white">
          <img alt="{{integration.type}} icon logo" src="../assets/{{integration.type}}_icon_logo.png" height="25" width="25" class="invert" />
          <span *ngIf="!isCollapsed">{{ integration.name }}</span>
        </span>
        </a>
      }
      @if (isLoggedIn) {
        <a mat-list-item
           [routerLink]="'/events'"
           [routerLinkActive]="path === '/events' ? '!bg-blue-600' : ''"
        >
          <span class="entry text-white">
            <mat-icon>receipt_long</mat-icon>
            <span *ngIf="!isCollapsed">Logs</span>
          </span>
        </a>
      }
      @if (showAdminBoard) {
      <h3 mat-subheader class="text-white pt-6">Admin</h3>
      <a mat-list-item
         [routerLink]="'/customers'"
         [routerLinkActive]="path === '/customers' ? '!bg-blue-600' : ''"
      >
        <span class="entry text-white">
          <mat-icon>group</mat-icon>
          <span *ngIf="!isCollapsed">Kunden</span>
        </span>
      </a>
      <a mat-list-item
         [routerLink]="'/users'"
         [routerLinkActive]="path === '/users' ? '!bg-blue-600' : ''"
      >
        <span class="entry text-white">
          <mat-icon>person</mat-icon>
          <span *ngIf="!isCollapsed">Benutzer</span>
        </span>
      </a>
      <a mat-list-item
         [routerLink]="'/events'"
         [routerLinkActive]="path === '/events' ? '!bg-blue-600' : ''"
      >
        <span class="entry text-white">
          <mat-icon>receipt_long</mat-icon>
          <span *ngIf="!isCollapsed">Logs</span>
        </span>
      </a>
      }
      <a mat-list-item
         class="mt-16"
         (click)="changeLanguage('de')"
      >
        <span class="entry text-white">
          DE
          <span *ngIf="!isCollapsed">Deutsch</span>
        </span>
      </a>
      <a mat-list-item
         (click)="changeLanguage('en')"
      >
        <span class="entry text-white">
          EN
          <span *ngIf="!isCollapsed">English</span>
        </span>
      </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="flex flex-row place-items-center p-5 w-full bg-white">
      @if (isMobile) {
      <button mat-icon-button aria-label="Menu icon" (click)="toggleMenu()" class="mr-2">
        <mat-icon>menu</mat-icon>
      </button>
      }
      <div class="pr-10">
        <a href="#"><img alt="we7" class="h-12" src="assets/img.png" /></a>
      </div>
      <div class="flex flex-row grow space-x-14" routerLinkActive="active">
      </div>

      <div class="flex flex-row space-x-8" *ngIf="!isLoggedIn">
        <div>
          <a href="/register" routerLink="register">{{'signup' | translate}}</a>
        </div>
        <div>
          <a href="/login" routerLink="login">{{'login' | translate}}</a>
        </div>
      </div>

      <div class="flex flex-row space-x-8" *ngIf="isLoggedIn">
        <div class="self-center">
          <a href="/profile" routerLink="profile">
            {{ email }}
          </a>
        </div>
        <div>
          <button mat-icon-button href (click)="logout()">
            <mat-icon>logout</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div id="app" class="h-screen flex flex-col">
      <div class="w-full h-full p-10 flex flex-col">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
